

const  categoryData = [
    {
      "name": "Brass Nut",
      "image": "https://m.media-amazon.com/images/I/61S8DxWQEKL._AC_UF1000,1000_QL80_.jpg",
      "description": "Thread-Bsp as per customer design, Extension Piece manufactured under strict Quality Control and can be manufactured as per customer specifications",
      "finished": "Available in Brass and chrome plating",
      "range": "Light, Medium and Heavy as per requirement",
      "tableImage": "/images/category-table/extention-peice.png",
      "link":"/category/sanitary/brass-nut"
    },
    {
      "name": "Hex Nipple",
      "image": "/images/category-images/Sanitary Parts/Hexl_Nipple.png",
      "description": "Thread-Bsp as per customer design, Extension Piece manufactured under strict Quality Control and can be manufactured as per customer specifications",
      "finished": "Available in Brass and chrome plating",
      "range": "Light, Medium and Heavy as per requirement",
      "tableImage": "/images/category-table/extention-peice.png",
      "link":"/category/sanitary/hex-nipple"
    },
    {
      "name": "Round Flange Tank Connector Single Side Move",
      "image": "/images/category-images/Sanitary Parts/ROUND FLANGE TANK CONNECTOR SINGLE SIDE MOVE.jpg",
      "description": "Thread-Bsp as per customer design, Extension Piece manufactured under strict Quality Control and can be manufactured as per customer specifications",
      "finished": "Available in Brass and chrome plating",
      "range": "Light, Medium and Heavy as per requirement",
      "tableImage": "/images/category-table/extention-peice.png",
      "link":"/category/sanitary/round-flange-tank-connector-single-side-move"
    },
    {
      "name": "CP Cross Tee",
      "image": "https://m.media-amazon.com/images/I/61S8DxWQEKL._AC_UF1000,1000_QL80_.jpg",
      "description": "Thread-Bsp as per customer design, Extension Piece manufactured under strict Quality Control and can be manufactured as per customer specifications",
      "finished": "Available in Brass and chrome plating",
      "range": "Light, Medium and Heavy as per requirement",
      "tableImage": "/images/category-table/extention-peice.png",
      "link":"/category/sanitary/cp-cross-tee"
    },
    {
      "name": "CP Hex Cap Female",
      "image": "https://m.media-amazon.com/images/I/61S8DxWQEKL._AC_UF1000,1000_QL80_.jpg",
      "description": "Thread-Bsp as per customer design, Extension Piece manufactured under strict Quality Control and can be manufactured as per customer specifications",
      "finished": "Available in Brass and chrome plating",
      "range": "Light, Medium and Heavy as per requirement",
      "tableImage": "/images/category-table/extention-peice.png",
      "link":"/category/sanitary/cp-hex-cap-female"
    },
    {
      "name": "CP Hex Nipple",
      "image": "https://m.media-amazon.com/images/I/61S8DxWQEKL._AC_UF1000,1000_QL80_.jpg",
      "description": "Thread-Bsp as per customer design, Extension Piece manufactured under strict Quality Control and can be manufactured as per customer specifications",
      "finished": "Available in Brass and chrome plating",
      "range": "Light, Medium and Heavy as per requirement",
      "tableImage": "/images/category-table/extention-peice.png",
      "link":"/category/sanitary/cp-hex-nipple"
    },
    {
      "name": "CP Male Female Elbow",
      "image": "https://m.media-amazon.com/images/I/61S8DxWQEKL._AC_UF1000,1000_QL80_.jpg",
      "description": "Thread-Bsp as per customer design, Extension Piece manufactured under strict Quality Control and can be manufactured as per customer specifications",
      "finished": "Available in Brass and chrome plating",
      "range": "Light, Medium and Heavy as per requirement",
      "tableImage": "/images/category-table/extention-peice.png",
      "link":"/category/sanitary/cp-male-female-elbow"
    },
    {
      "name": "CP Plug Male & Female",
      "image": "https://m.media-amazon.com/images/I/61S8DxWQEKL._AC_UF1000,1000_QL80_.jpg",
      "description": "Thread-Bsp as per customer design, Extension Piece manufactured under strict Quality Control and can be manufactured as per customer specifications",
      "finished": "Available in Brass and chrome plating",
      "range": "Light, Medium and Heavy as per requirement",
      "tableImage": "/images/category-table/extention-peice.png",
      "link":"/category/sanitary/"
    },
    {
      "name": "CP Socket",
      "image": "https://m.media-amazon.com/images/I/61S8DxWQEKL._AC_UF1000,1000_QL80_.jpg",
      "description": "Thread-Bsp as per customer design, Extension Piece manufactured under strict Quality Control and can be manufactured as per customer specifications",
      "finished": "Available in Brass and chrome plating",
      "range": "Light, Medium and Heavy as per requirement",
      "tableImage": "/images/category-table/extention-peice.png",
      "link":"/category/sanitary/cp-socket"
    },
    {
      "name": "CP Waste Coupling",
      "image": "https://m.media-amazon.com/images/I/61S8DxWQEKL._AC_UF1000,1000_QL80_.jpg",
      "description": "Thread-Bsp as per customer design, Extension Piece manufactured under strict Quality Control and can be manufactured as per customer specifications",
      "finished": "Available in Brass and chrome plating",
      "range": "Light, Medium and Heavy as per requirement",
      "tableImage": "/images/category-table/extention-peice.png",
      "link":"/category/sanitary/cp-waste-coupling"
    },
    {
      "name": "Tank Connector Double Side Move",
      "image": "/images/category-images/Sanitary Parts/TANK CONNECTOR DOUBLE SIDE MOVE.jpg",
      "description": "Thread-Bsp as per customer design, Extension Piece manufactured under strict Quality Control and can be manufactured as per customer specifications",
      "finished": "Available in Brass and chrome plating",
      "range": "Light, Medium and Heavy as per requirement",
      "tableImage": "/images/category-table/extention-peice.png",
      "link":"/category/sanitary/tank-connector-double-side-move"
    },
    {
      "name": "Elbow Coupling",
      "image": "https://m.media-amazon.com/images/I/61S8DxWQEKL._AC_UF1000,1000_QL80_.jpg",
      "description": "Thread-Bsp as per customer design, Extension Piece manufactured under strict Quality Control and can be manufactured as per customer specifications",
      "finished": "Available in Brass and chrome plating",
      "range": "Light, Medium and Heavy as per requirement",
      "tableImage": "/images/category-table/extention-peice.png",
      "link":"/category/sanitary/elbow-coupling"
    },
    {
      "name": "Female Plug",
      "image": "https://m.media-amazon.com/images/I/61S8DxWQEKL._AC_UF1000,1000_QL80_.jpg",
      "description": "Thread-Bsp as per customer design, Extension Piece manufactured under strict Quality Control and can be manufactured as per customer specifications",
      "finished": "Available in Brass and chrome plating",
      "range": "Light, Medium and Heavy as per requirement",
      "tableImage": "/images/category-table/extention-peice.png",
      "link":"/category/sanitary/female-plug"
    },
    {
      "name": "Hose Nipple",
      "image": "https://m.media-amazon.com/images/I/61S8DxWQEKL._AC_UF1000,1000_QL80_.jpg",
      "description": "Thread-Bsp as per customer design, Extension Piece manufactured under strict Quality Control and can be manufactured as per customer specifications",
      "finished": "Available in Brass and chrome plating",
      "range": "Light, Medium and Heavy as per requirement",
      "tableImage": "/images/category-table/extention-peice.png",
      "link":"/category/sanitary/hose-nipple"
    },
    {
      "name": "Kim Nipple",
      "image": "https://m.media-amazon.com/images/I/61S8DxWQEKL._AC_UF1000,1000_QL80_.jpg",
      "description": "Thread-Bsp as per customer design, Extension Piece manufactured under strict Quality Control and can be manufactured as per customer specifications",
      "finished": "Available in Brass and chrome plating",
      "range": "Light, Medium and Heavy as per requirement",
      "tableImage": "/images/category-table/extention-peice.png",
      "link":"/category/sanitary/kim-nipple"
    },
    {
      "name": "Long Nipple",
      "image": "https://m.media-amazon.com/images/I/61S8DxWQEKL._AC_UF1000,1000_QL80_.jpg",
      "description": "Thread-Bsp as per customer design, Extension Piece manufactured under strict Quality Control and can be manufactured as per customer specifications",
      "finished": "Available in Brass and chrome plating",
      "range": "Light, Medium and Heavy as per requirement",
      "tableImage": "/images/category-table/extention-peice.png",
      "link":"/category/sanitary/long-nipple"
    },{
      "name": "Male Plug",
      "image": "https://m.media-amazon.com/images/I/61S8DxWQEKL._AC_UF1000,1000_QL80_.jpg",
      "description": "Thread-Bsp as per customer design, Extension Piece manufactured under strict Quality Control and can be manufactured as per customer specifications",
      "finished": "Available in Brass and chrome plating",
      "range": "Light, Medium and Heavy as per requirement",
      "tableImage": "/images/category-table/extention-peice.png",
      "link":"/category/sanitary/male-plug"
    },{
      "name": "Reducing Bush",
      "image": "/images/category-images/Sanitary Parts/reducing bush.jpg",
      "description": "Thread-Bsp as per customer design, Extension Piece manufactured under strict Quality Control and can be manufactured as per customer specifications",
      "finished": "Available in Brass and chrome plating",
      "range": "Light, Medium and Heavy as per requirement",
      "tableImage": "/images/category-table/extention-peice.png",
      "link":"/category/sanitary/reducing-bush"
    },{
      "name": "Socket Round",
      "image": "https://m.media-amazon.com/images/I/61S8DxWQEKL._AC_UF1000,1000_QL80_.jpg",
      "description": "Thread-Bsp as per customer design, Extension Piece manufactured under strict Quality Control and can be manufactured as per customer specifications",
      "finished": "Available in Brass and chrome plating",
      "range": "Light, Medium and Heavy as per requirement",
      "tableImage": "/images/category-table/extention-peice.png",
      "link":"/category/sanitary/socket-round"
    },{
      "name": "Tee Coupling",
      "image": "https://m.media-amazon.com/images/I/61S8DxWQEKL._AC_UF1000,1000_QL80_.jpg",
      "description": "Thread-Bsp as per customer design, Extension Piece manufactured under strict Quality Control and can be manufactured as per customer specifications",
      "finished": "Available in Brass and chrome plating",
      "range": "Light, Medium and Heavy as per requirement",
      "tableImage": "/images/category-table/extention-peice.png",
      "link":"/category/sanitary/tee-coupling"
    },{
      "name": "UNION",
      "image": "/images/category-images/Sanitary Parts/UNION 1.jpg",
      "description": "Thread-Bsp as per customer design, Extension Piece manufactured under strict Quality Control and can be manufactured as per customer specifications",
      "finished": "Available in Brass and chrome plating",
      "range": "Light, Medium and Heavy as per requirement",
      "tableImage": "/images/category-table/extention-peice.png",
      "link":"/category/sanitary/union"
    },{
      "name": "Water Meter Connector",
      "image": "https://m.media-amazon.com/images/I/61S8DxWQEKL._AC_UF1000,1000_QL80_.jpg",
      "description": "Thread-Bsp as per customer design, Extension Piece manufactured under strict Quality Control and can be manufactured as per customer specifications",
      "finished": "Available in Brass and chrome plating",
      "range": "Light, Medium and Heavy as per requirement",
      "tableImage": "/images/category-table/extention-peice.png",
      "link":"/category/sanitary/water-meter-connctor"
    },
  
  
    // cable gland
  
    {
        "name": "Earthing Tag",
        "image": "https://m.media-amazon.com/images/I/61S8DxWQEKL._AC_UF1000,1000_QL80_.jpg",
        "description": "Thread-Bsp as per customer design, Extension Piece manufactured under strict Quality Control and can be manufactured as per customer specifications",
        "finished": "Available in Brass and chrome plating",
        "range": "Light, Medium and Heavy as per requirement",
        "tableImage": "/images/category-table/extention-peice.png",
        "link":"/category/cables/earthing-tag"
    },
    {
        "name": "Brass Reducers",
        "image": "https://m.media-amazon.com/images/I/61S8DxWQEKL._AC_UF1000,1000_QL80_.jpg",
        "description": "Thread-Bsp as per customer design, Extension Piece manufactured under strict Quality Control and can be manufactured as per customer specifications",
        "finished": "Available in Brass and chrome plating",
        "range": "Light, Medium and Heavy as per requirement",
        "tableImage": "/images/category-table/extention-peice.png",
        "link":"/category/cables/brass-reducers"
    },
    {
        "name": "Brass Stopping Plug",
        "image": "/images/category-images/cable-gland/BRASS STOPPING PLUC.jpg",
        "description": "Thread-Bsp as per customer design, Extension Piece manufactured under strict Quality Control and can be manufactured as per customer specifications",
        "finished": "Available in Brass and chrome plating",
        "range": "Light, Medium and Heavy as per requirement",
        "tableImage": "/images/category-table/extention-peice.png",
        "link":"/category/cables/brass-stopping-plug"
    },
    {
        "name": "Extension Pieces",
        "image": "https://m.media-amazon.com/images/I/61S8DxWQEKL._AC_UF1000,1000_QL80_.jpg",
        "description": "Thread-Bsp as per customer design, Extension Piece manufactured under strict Quality Control and can be manufactured as per customer specifications",
        "finished": "Available in Brass and chrome plating",
        "range": "Light, Medium and Heavy as per requirement",
        "tableImage": "/images/category-table/extention-peice.png",
        "link":"/category/cables/extention-piece"
    },
    {
        "name": "Line Taps / Split Bolt",
        "image": "https://m.media-amazon.com/images/I/61S8DxWQEKL._AC_UF1000,1000_QL80_.jpg",
        "description": "Thread-Bsp as per customer design, Extension Piece manufactured under strict Quality Control and can be manufactured as per customer specifications",
        "finished": "Available in Brass and chrome plating",
        "range": "Light, Medium and Heavy as per requirement",
        "tableImage": "/images/category-table/extention-peice.png",
        "link":"/category/cables/line-taps"
    },
    {
        "name": "Lock Nut",
        "image": "https://m.media-amazon.com/images/I/61S8DxWQEKL._AC_UF1000,1000_QL80_.jpg",
        "description": "Thread-Bsp as per customer design, Extension Piece manufactured under strict Quality Control and can be manufactured as per customer specifications",
        "finished": "Available in Brass and chrome plating",
        "range": "Light, Medium and Heavy as per requirement",
        "tableImage": "/images/category-table/extention-peice.png",
        "link":"/category/cables/lock-nut"
    },
    {
        "name": "PG Brass Cable Gland Nickle Plated",
        "image": "https://m.media-amazon.com/images/I/61S8DxWQEKL._AC_UF1000,1000_QL80_.jpg",
        "description": "Thread-Bsp as per customer design, Extension Piece manufactured under strict Quality Control and can be manufactured as per customer specifications",
        "finished": "Available in Brass and chrome plating",
        "range": "Light, Medium and Heavy as per requirement",
        "tableImage": "/images/category-table/extention-peice.png",
        "link":"/category/cables/pg-brass-cable-gland"
    },
    {
        "name": "Split Bolt Connector With Round Head",
        "image": "https://m.media-amazon.com/images/I/61S8DxWQEKL._AC_UF1000,1000_QL80_.jpg",
        "description": "Thread-Bsp as per customer design, Extension Piece manufactured under strict Quality Control and can be manufactured as per customer specifications",
        "finished": "Available in Brass and chrome plating",
        "range": "Light, Medium and Heavy as per requirement",
        "tableImage": "/images/category-table/extention-peice.png",
        "link":"/category/cables/split-bolt-connector"
    }
  
  ]

export default categoryData;